  const SIG_FLAG = '/media/flags/singapore.svg'
  export const StaticCountrySelect = () => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: 6,
        paddingRight: 6,
        height: "100%",
        pointerEvents: "none",
        userSelect: "none",
      }}
      aria-hidden="true"
    >
      <img
        src={SIG_FLAG}
        alt="Singapore"
        style={{
          height: 20,
          marginRight: 6,
          width: "auto",
          display: "block",
        }}
      />
    </div>
  );